import React from 'react';
import { compose } from 'recompose';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';

import Input from '../../../common/RadioInput/Input';
import Card from '../../../Card';

import { COLORS } from '../../../../constants/styles';

import styles from '../index.styl';

const ReportListItem = ({ item: { name, id }, selected }) => {
  return (
    <div styleName="list-item">
      <Card
        className="fw6"
        text={{
          primary: name,
        }}
        additionalContent={{
          left: (
            <Input
              size={16}
              color={COLORS.bluePrimary}
              checked={selected === id}
              readOnly
            />
          ),
        }}
      />
    </div>
  );
};

ReportListItem.propTypes = {
  item: PropTypes.object.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  selected: PropTypes.number.isRequired,
};

export default compose(
  CSSModules(styles, { allowMultiple: true })(ReportListItem),
);



// WEBPACK FOOTER //
// ./src/components/Ui/Report/ReportListItem/index.jsx